import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './mid_session_offline_icon.svg'

const MidSessionOfflineIcon: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />
export default MidSessionOfflineIcon
